module.exports = __webpack_public_path__ + "img/logo_edtech2.f5b51164.png";